import axiosInstance from './apiConfig';

export const getAllRegistrations = async (search = ''): Promise<any> => {
  try {
    let url = '/registration/getAll';
    const params = new URLSearchParams();

    if (search) params.append('search', search);

    if (params.toString().length > 0) {
      url += '?' + params.toString();
    }

    const response = await axiosInstance.get(url);

    return response.data;
  } catch (error) {
    throw new Error(`fetch registrations failed: ${error}`);
  }
};

export const addNewRegistration = async (data: any): Promise<any> => {
  try {
    const response = await axiosInstance.post('/registration/add', data);

    return response.data;
  } catch (error) {
    throw new Error(`add registration failed: ${error}`);
  }
};

export const getByOrganizationIdAndCategory = async (
  id: number,
  category: string,
): Promise<any> => {
  try {
    const response = await axiosInstance.get(
      '/registration/getByOrganizationIdAndCategory?organizationId=' +
        id +
        '&category=' +
        category,
    );

    return response.data;
  } catch (error) {
    throw new Error(`fetch registration by id failed: ${error}`);
  }
};

export const editNewRegistration = async (
  id: number,
  data: any,
): Promise<any> => {
  try {
    const response = await axiosInstance.put(
      '/registration/update?id=' + id,
      data,
    );

    return response.data;
  } catch (error) {
    throw new Error(`edit registration failed: ${error}`);
  }
};

export const removeRegistration = async (id: number): Promise<any> => {
  try {
    const response = await axiosInstance.delete(
      '/registration/delete?id=' + id,
    );

    return response.data;
  } catch (error) {
    throw new Error(`remove registration failed: ${error}`);
  }
};

export const exportRegistrations = async (
  organizationId: number,
  category: string,
): Promise<Blob> => {
  try {
    const response = await axiosInstance.get(
      `/registration/export?organizationId=${organizationId}&category=${category}`,
      {
        responseType: 'blob',
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(`export registrations failed: ${error}`);
  }
};

export const uploadRegistrations = async (file: File): Promise<any> => {
  const data = new FormData();
  data.append('file', file);

  try {
    const response = await axiosInstance.post('/registration/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};
